import React from 'react';
import { Panel } from '../Panel';
import { Rotation } from './WRotation';

interface IWatchRotationProps {
	id: number
	title: string
	handleRemoveWidget: (id: number) => void
}

const updateWidget = () => null

export const WatchRotation: React.FunctionComponent<IWatchRotationProps> = ({ id, title, handleRemoveWidget }) => (
	<Panel
		isActive={true}
		handler="watch-handle pt-1 pb-0"
		hideHeader={false}
		canScroll={true}
		id={id}
		title={title}
		handleRemoveWidget={handleRemoveWidget}
		left={0}
		top={0}
		height={0}
		width={0}
		updateLayout={updateWidget}
		zIndex={0}
	>
		<Rotation id={id} />
	</Panel>
)